import { Component, NgZone, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../environments/environment';
import { IonModal, IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { GlobalService } from './services/global.service';
import { DevNavComponent } from './components/dev-nav/dev-nav.component';

declare var window:any;
@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    imports: [IonApp, IonRouterOutlet, IonModal, DevNavComponent]
})
export class AppComponent {
  environment;
  /** Barre d'onglets de navigation : outil de dev, le LMS gère la navigation en production. */
  showDevNav = !environment.production;
  @ViewChild('loading') loadingModal: IonModal
  customMessage: string;

  // L'authentification (accesstoken en paramètre d'URL, redirection login/unauthorized)
  // est gérée par authGuard sur chaque route protégée, cf. guards/auth.guard.ts.
  constructor(public router: Router, public globalService: GlobalService, public ngZone : NgZone) {
    this.environment = environment
    this.globalService.appComponent = this;
  }
}
